import styled from 'styled-components';
import { Black, White } from '../../colors';


export const Container = styled.div`
    width: 100vw;
    max-width: 1200px;
    height: 100vh;
    position: relative;
    display: block;
    h1{
        text-transform: uppercase;
        font-family: 'Josefin Sans';
        text-align: center;
        padding-top: 3rem;
        margin: 0 25%;
        display:flex;
        margin-bottom: 2em;
        justify-content: center;
    }
    &:nth-child(8){
        margin-bottom: 1em;
    }

    @media (min-width: 200px){
        h1{
            display: block;
            position: relative;
            margin: 20% 25%;
            margin-top: 35%;
        }
    }

    
    @media (max-width: 800px){
        width: 66vw;

        h1{
            margin: 20% 75%;
            text-align: center;
            display: flex;
        }
    }
   
    @media (min-width: 1000px){
        h1{
            left: 0;
            display: flex;
            margin: 2em 1.2em;
            justify-content: flex-start;
        }
    }
    @media (max-width: 600px){
        h1{
            margin: 45% 75%;
            margin-top: 60%;
        }
    }
    @media (max-width: 2560px){
        max-width: 1200px;
        margin: 0 auto;
    }
    @media (max-width: 1000px){
        h1{
            margin: 3em auto;
        }
    }
`;

export const Button = styled.button`
    width: 40vw;
    height: 5vh;
    margin:0 0 5em 32%;
    background-color: ${White};
    border: 1.5px solid ${Black};
    font-family: 'Alata';
    word-spacing: 0.3em;
    letter-spacing: 0.2em;
    cursor: pointer;

    @media (min-width: 200px){
        margin:0 0 5em 32%;
        position: relative;
        top: -4em;
    }
    @media (max-width: 600px){
        top: 3rem;
        margin:0 0 2em 30%;
    }

    @media (max-width: 800px){
        margin-top: 3em;
        margin-left: 45%;
    }
    @media (min-width: 1000px){
        position: absolute;
        margin: 7em 0 25em 55%;
    }

    @media (max-width: 2560px){
        width: 10vw;
        position: absolute;
        bottom: 0;
        right: calc(100% - 56.9vw );
        top: calc(100% - 106vh);
    }



    @media (max-width: 1800px){
        right: 9%;
    }
    @media (max-width: 1000px){
        position: relative;
        width: 35vw;
        margin: 5vh calc(100vw - 117%);
        bottom: 0;
    }
`;

export const CardContainer = styled.div`
    @media (min-width: 1000px){
        display: flex;
        width: 100%;
        height: 100%;
        flex-wrap: wrap;
        max-width: 1200px;
        margin: 0 1.5em;
    }
`;